export const __BROWSER__ =
  typeof window !== 'undefined' && typeof window.document !== 'undefined';

/* eslint-disable no-restricted-globals */
export const __WORKER__ =
  typeof self === 'object' &&
  self.constructor &&
  self.constructor.name === 'DedicatedWorkerGlobalScope';
/* eslint-enable no-restricted-globals */

export const __NODE__ =
  typeof process !== 'undefined' && process.versions != null && process.versions.node != null;

export const __DOM__ = () =>
  (typeof window !== 'undefined' && window.name === 'nodejs') ||
  navigator.userAgent.includes('Node.js') ||
  navigator.userAgent.includes('jsdom');

export default {
  __BROWSER__,
  __WORKER__,
  __NODE__,
  __DOM__
};
